import adminUserService from '../../services/admin/AdminUserService'

// Requisições em voo, deliberadamente FORA do state: promessa não é estado de
// UI, e deixá-la reativa faria o Vue observar um objeto que ninguém renderiza.
// Servem para deduplicar — a listagem e o formulário podem montar quase juntos,
// e sem isso os dois disparariam a mesma consulta.
let optionsRequest = null

export const adminUserModule = {
  namespaced: true,
  state: {
    users: [],
    pagination: {
      total: 0,
      current_page: 1,
      per_page: 20,
      last_page: 1,
    },
    // Só o que não sai da ITENS. Fabricantes, grupos, marcas e listas de
    // oferta são pesquisados sob demanda por `searchOptionAtributos` — carregar
    // as quatro listas inteiras aqui era o que obrigava a cachear dado que o
    // ERP muda a qualquer hora.
    options: {
      precos: [],
      filiais: [],
    },
    firstLoad: true,
    loading: true,
    saving: false,
    // Guardas de cache. `firstLoad` NÃO serve para isso — ele só controla o
    // spinner da listagem e é zerado por fetchUsers.
    optionsLoaded: false,
  },
  mutations: {
    SET_USERS(state, payload) {
      state.users = payload.data || []
      if (payload.total !== undefined) {
        state.pagination = {
          total: payload.total,
          current_page: payload.current_page,
          per_page: payload.per_page,
          last_page: payload.last_page,
        }
      }
    },
    SET_OPTIONS(state, payload) {
      state.options = payload
      state.optionsLoaded = true
    },
    SET_LOADING(state, loading) {
      state.loading = loading
    },
    SET_SAVING(state, saving) {
      state.saving = saving
    },
    SET_FIRST_LOAD(state, payload) {
      state.firstLoad = payload
    },
  },
  actions: {
    async fetchUsers({ commit }, params = {}) {
      commit('SET_LOADING', true)
      try {
        const data = await adminUserService.getUsers(params)
        commit('SET_USERS', data)
        return data
      } finally {
        commit('SET_LOADING', false)
        commit('SET_FIRST_LOAD', false)
      }
    },
    // O usuário, o bloco `acesso` dele e o que o grupo dele concede (#64).
    async fetchUser(context, id) {
      return await adminUserService.getUser(id)
    },
    async createUser({ commit, dispatch }, payload) {
      commit('SET_SAVING', true)
      try {
        const data = await adminUserService.createUser(payload)
        // A contagem de membros da lista de grupos (#64) mudou.
        dispatch('adminGrupoModule/invalidateGrupos', null, { root: true })
        return data
      } finally {
        commit('SET_SAVING', false)
      }
    },
    async updateUser({ commit, dispatch }, { payload, id }) {
      commit('SET_SAVING', true)
      try {
        const data = await adminUserService.updateUser(payload, id)
        dispatch('adminGrupoModule/invalidateGrupos', null, { root: true })
        return data
      } finally {
        commit('SET_SAVING', false)
      }
    },
    async deleteUser({ commit }, id) {
      commit('SET_SAVING', true)
      try {
        return await adminUserService.deleteUser(id)
      } finally {
        commit('SET_SAVING', false)
      }
    },
    // Carga de referência: fabricantes, marcas, grupos e listas de oferta saem
    // de quatro SELECT DISTINCT sobre a ITENS. Buscar uma vez por sessão basta,
    // e é o que tira a chamada do caminho `listagem → novo/editar`.
    async fetchOptions({ commit, state }, { force = false } = {}) {
      if (state.optionsLoaded && !force) return state.options
      if (optionsRequest && !force) return optionsRequest

      if (!state.firstLoad) commit('SET_LOADING', true)
      optionsRequest = adminUserService
        .getOptions()
        .then((data) => {
          commit('SET_OPTIONS', data)
          return data
        })
        .finally(() => {
          optionsRequest = null
          if (!state.firstLoad) commit('SET_LOADING', false)
        })

      return optionsRequest
    },
    // Sem memoização de propósito: é a busca que mantém o Admin em dia com o
    // ERP desktop, onde um fabricante ou uma lista de oferta pode nascer a
    // qualquer momento. O backend só cacheia a primeira página, por 1 minuto.
    async searchOptionAtributos(context, { tipo, search = '', limit = 50 }) {
      const response = await adminUserService.getOptionAtributos({
        tipo,
        search,
        limit,
      })
      return (response && response.data) || []
    },
  },
  getters: {
    users: (state) => state.users,
    pagination: (state) => state.pagination,
    options: (state) => state.options,
    loading: (state) => state.loading,
    saving: (state) => state.saving,
  },
}
